


















































import { defineComponent, PropType } from "@vue/composition-api";
import { PurchaseInfo } from "@/payments/types";
import { paymentMethodNames } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "SubscriptionConfirmModal",
  components: { FormatMoney, BaseButton, BaseConfirm },
  props: {
    cost: { type: Number },
    currentAmount: { type: Number },
    mainCurrency: { type: String, required: true },
    purchaseInfo: { type: Object as PropType<PurchaseInfo>, required: true },
    loading: { type: Boolean, required: true },
    show: { type: Boolean, required: true },
  },
  setup() {
    return { paymentMethodNames };
  },
});
